var angular = require('angular')
var langCs = require('./i18n/cs.js').cs
var langEn = require('./i18n/en.js').en
require('angular-sanitize')
var guid = require('aem-libs/src/guid')

angular.module('inputCheckboxCmp', ['ngSanitize'])
  .factory('visibilityDependencyDataservice', require('../../../../services/visibility-dependency.dataservice'))
  .component('inputCheckbox', {
    template: require('./input-checkbox.component.tpl.html'),
    controller: InputCheckboxCtrl,
    controllerAs: 'vm',
    bindings: {
      formField: '<',
      value: '=',
      resetVisibleFieldsValidity: '&'
    }
  })

InputCheckboxCtrl.$inject = ['$timeout', 'visibilityDependencyDataservice', 'i18n']

function InputCheckboxCtrl ($timeout, visibilityDependencyDataservice, i18n) {
  var vm = this
  vm.showLabel = true

  vm.$onInit = function () {
    i18n.appendLangFile('cs', langCs)
    i18n.appendLangFile('en', langEn)
    vm.fieldId = 'field_' + vm.formField.id + '-' + guid()
  }

  vm.$onChanges = function (changesObj) {
    if (changesObj.formField) {
      vm.type = getType()
    }
  }

  vm.changed = false
  vm.checkboxValues = {}

  angular.forEach(vm.formField.optionsI18N, function (item) {
    vm.checkboxValues[item] = false
  })
  var hasChecked = !angular.isUndefined(vm.value[vm.formField.id])
  if (hasChecked) {
    angular.forEach(vm.value[vm.formField.id], function (item) {
      vm.checkboxValues[item] = true
    })
  }

  $timeout(function () {
    if (vm.formField.mandatory) {
      vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('required', false)
    }
    if (vm.formField.defaultValueI18N) {
      vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('required', true)
    }
  }, 0)

  if (vm.formField.defaultValueI18N) {
    if (vm.formField.defaultValueI18N.indexOf('|')) {
      var result = []
      angular.forEach(vm.formField.defaultValueI18N.split('|'), function (item) {
        var val = item
        vm.checkboxValues[val] = true
        result.push(val)
      })
      vm.value[vm.formField.id] = result
    } else {
      vm.checkboxValues[vm.formField.defaultValueI18N] = true
      vm.value[vm.formField.id] = [vm.formField.defaultValueI18N]
    }
  }

  vm.onChange = function () {
    vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('required', true)
    vm.changed = true
    var result = []
    angular.forEach(vm.checkboxValues, function (value, key) {
      if (value) {
        result.push(key)
      }
    })
    if (vm.formField.mandatory && !result.length) {
      vm.changed = false
      vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('required', false)
    }
    vm.value[vm.formField.id] = result
    changed(vm.formField.id)
  }

  function changed (id) {
    var values = vm.value[id]
    var visibleNow = visibilityDependencyDataservice.nodeCheckboxValuesChanged(id, values)
    if (visibleNow.length) {
      vm.resetVisibleFieldsValidity()
    }
  }

  function getType () {
    if (vm.formField.hidden) {
      return 'hidden'
    } else {
      return 'checkbox'
    }
  }
}
